import Chart from "react-apexcharts";

const PyramidChart = () => {
  const options = {
    chart: {
      type: "bar",
      dropShadow: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
      fontFamily: "IRANSansWeb, sans-serif",
    },

    tooltip: {
      enabled: false,
      shared: false,
      intersect: false,
    },

    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },

    grid: {
      show: false,
       padding: {
    top: -10,
    bottom: -10,
  },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: "80%",
        isFunnel: true,
      },
    },

    colors: [
      "#1d3557",
      "#305d98",
      "#3f7bc9",
      "#3e8ce8",
    ],

    dataLabels: {
      enabled: true,
      offsetY: -3,
      style: {
        colors: ["#ffffff"],
        fontFamily: "IRANSansWeb",
        fontSize: "13px",
        fontWeight: 400,
      },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex],
    },

    xaxis: {
       categories: [
        "در حال اجرا یا ارزیابی (015 طرح)",
        "خاتمه یافته (286 طرح)",
        "بایگانی شده (2981 طرح)",
        "ثبت شده (4803 طرح)",
      ],
    },

    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: "Food",
      data: [150, 250, 350, 450],
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={290}
    />
  );
};

export default PyramidChart;